/* import __COLOCATED_TEMPLATE__ from './pre-verify.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { setInputEnterKeyHint, updateError } from '@square/ember-multipass-components/utils/ember-multipass-input-util';
let SecureContactModalEnrollPreVerifyComponent = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipassfe-client'), _class = class SecureContactModalEnrollPreVerifyComponent extends Component {
  get verificationCodeLengthErrorTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.verification_code_length';
  }
  get invalidVerificationCodeErrorTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.invalid_verification_code';
  }
  get temporaryLockoutTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.temporary_lockout';
  }
  get unknownErrorTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.unknown';
  }
  get isEmailMethod() {
    return this.args.detail.email;
  }
  get isPhoneMethod() {
    return this.args.detail.phone;
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "logger", _descriptor2, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor3, this);
    _initializerDefineProperty(this, "codeError", _descriptor4, this);
    _initializerDefineProperty(this, "loading", _descriptor5, this);
    _initializerDefineProperty(this, "validating", _descriptor6, this);
    _defineProperty(this, "code", '');
    _defineProperty(this, "codeInput", void 0);
    _defineProperty(this, "handleCodeInputDidInsert", element => {
      this.codeInput = element;
    });
  }
  updateCodeError(err) {
    if (err) {
      this.codeError = err;
      updateError(this.codeInput, 'code-error');
    } else if (this.code.length < 6) {
      this.codeError = this.intl.t(this.args.tPrefix + this.verificationCodeLengthErrorTLabel);
      updateError(this.codeInput, 'code-error');
    } else {
      this.codeError = undefined;
      updateError(this.codeInput);
    }
  }
  checkEnterPressed(event) {
    if (event.key === 'Enter') {
      this.submitDebounced();
    }
  }
  updateCode(event) {
    const currentInput = document.querySelector('.verification-code-input').shadowRoot.activeElement;
    if (!currentInput.hasAttribute('enterKeyHint')) {
      setInputEnterKeyHint(currentInput, 'go');
    }
    this.code = event.detail.code;
    if (this.validating) {
      this.updateCodeError();
    }
  }
  submitDebounced() {
    debounce(this, this.submit, 500, true);
  }
  async submit() {
    this.validating = true;
    this.updateCodeError();
    if (this.codeError || this.loading) {
      return;
    }
    try {
      const data = {
        verification_code: this.code
      };
      if (this.args.detail?.phone) {
        data.secure_contact_details = {
          phone: this.args.detail.phone
        };
      } else if (this.args.detail?.email) {
        data.secure_contact_details = {
          email: this.args.detail.email
        };
      }
      this.loading = true;
      await this.multipassfeClient.verifySecureContact(data);
      // If verify succeeds, pull fresh secure contacts to get updated verified_at dates
      await this.multipassfeClient.listSecureContact();
      this.args.next();
    } catch (e) {
      switch (e.message) {
        case 'TEMPORARY_LOCKOUT':
          this.updateCodeError(this.intl.t(this.args.tPrefix + this.temporaryLockoutTLabel));
          break;
        case 'INVALID_CREDENTIALS':
          this.updateCodeError(this.intl.t(this.args.tPrefix + this.invalidVerificationCodeErrorTLabel));
          break;
        default:
          this.logger.sentryError(e);
          this.updateCodeError(this.intl.t(this.args.tPrefix + this.unknownErrorTLabel));
      }
    } finally {
      this.loading = false;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "codeError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "validating", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "checkEnterPressed", [action], Object.getOwnPropertyDescriptor(_class.prototype, "checkEnterPressed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submitDebounced", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submitDebounced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype), _class);
export { SecureContactModalEnrollPreVerifyComponent as default };